import React, { useEffect, useState } from "react";
import { FormattedMessage, useIntl } from "react-intl";
import { StaticImage } from "gatsby-plugin-image";
import { LocalizedLink } from "gatsby-plugin-i18n-l10n";

import LanguageSwitcher from "../LanguageSwitcher";
import CitySwitcher from "../CitySwitcher";
import CtaButton from "../CtaButton";

import FacebookWidget from "../FacebookWidget";


import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import Fade from '@mui/material/Fade';

import { Global } from "@emotion/react";
import {emotionGlobalCss} from "./styles";
import MainNavigation from "../testMenu2";
import { Box } from "@mui/material";

export default function Header() {
    const [isScrolled, setIsScrolled] = useState<any>({});
    const intl = useIntl();
    const t = intl.formatMessage;
    const [windowWidth, setWindowWidth] = useState<any>(typeof window !== 'undefined' && window.innerWidth);

    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
    const open = Boolean(anchorEl);
    const handleClick = (event: React.MouseEvent<HTMLElement>) => { setAnchorEl(event.currentTarget); };
    const handleClose = () => { setAnchorEl(null); };

    useEffect(() => {
        if (typeof window !== "undefined"){
        const detectScroll = () => setIsScrolled({ scroll: window.scrollY });
        const detectSize = () => setWindowWidth(window.innerWidth);
        //console.log("window.innerWidth: ", window.innerWidth);
        window.addEventListener("scroll", detectScroll );
        window.addEventListener('resize', detectSize)
        return () => { window.removeEventListener('resize', detectSize); window.removeEventListener('scroll', detectScroll); }
        }return;
    }, []);

    useEffect(() => {

        isScrolled.scroll > 5 ? (document.body.style.margin = "-122px 0") : (document.body.style.margin = "0px 0");
        document.body.style.transition = "margin 0.75s";

    }, [isScrolled]);
    
    
    const position = isScrolled.scroll > 5 ? "fixed" : "static";
    
    return (
        <>
         <Global styles={emotionGlobalCss} />
        {/* <Box className={`header-container ${isScrolled.scroll > 5 ? "sticky" : ""}`} > */}
        <Box sx={{maxWidth:"100%"}} >
            {/* <div id="fb-root"></div> */}
            <div className="headerMain" >
                <div className="logoArea" >
                    <LocalizedLink to="/">
                        <StaticImage src="../../images/logoTransparentBackgroundd400.png" alt={t({ id: "altTag.logoImage" })} imgStyle={{objectFit: "contain", maxHeight:"70px"}}/>
                    </LocalizedLink>
                </div>

                <FacebookWidget position={position}/>
                
            </div>
            <MainNavigation windowWidth={windowWidth} position={position}/>
            {/* < nav
                className="navbar"
                role="navigation"
                aria-label="Main"
                itemScope
                itemType="https://schema.org/SiteNavigationElement"
            >
                <input type="checkbox" />
                <div className="burgerMenuModule" >
                    <span className="burgerMenu bar1" > </span>
                    < span className="burgerMenu bar2" > </span>
                    < span className="burgerMenu bar3" > </span>
                </div>

                < div className="roundLogo" >
                    <LocalizedLink to="/" >
                        <StaticImage src="../../images/InversedColor.png" alt={t({ id: "altTag.roundLogo" })} />
                    </LocalizedLink>
                </div>
                <ul className="menu" >
                    <li className="menuItem" >
                        <LocalizedLink to="/" aria-current="page" > <span className="home"  > <FormattedMessage id="nav.homepage" /> </span> </LocalizedLink>
                    </li>
                    <li className="menuItem" >
                        <LocalizedLink to="/solutions" > <span className="solutions" > <FormattedMessage id="nav.solutions" /> </span> </LocalizedLink>
                    </li>
                    <li className="menuItem" >
                        <a onClick={handleClick} > <span className="portfolio"  > <FormattedMessage id="nav.resources" /> </span> </a> */}
                        {/* <Menu
                            id="fade-menu"
                            MenuListProps={{ 'aria-labelledby': 'fade-button', }}
                            anchorEl={anchorEl}
                            open={open}
                            onClose={handleClose}
                            TransitionComponent={Fade}
                            style={{width:"320px"}}
                        >
                            <MenuItem onClick={handleClose}><LocalizedLink to="/portfolio" className="subMenuItems" ><FormattedMessage id="nav.portfolio" /> </LocalizedLink></MenuItem>
                            <MenuItem onClick={handleClose}><LocalizedLink to="/referral" className="subMenuItems" ><FormattedMessage id="nav.referrals" /> </LocalizedLink></MenuItem>
                            <MenuItem onClick={handleClose}><LocalizedLink to="/governments-grants-incentives" className="subMenuItems" ><FormattedMessage id="nav.governmentsGrants" /> </LocalizedLink></MenuItem> */}
                            {/* <MenuItem onClick={handleClose}><LocalizedLink to="/faq" className="subMenuItems" ><FormattedMessage id="nav.faq" /> </LocalizedLink></MenuItem> */}
                            {/* <MenuItem onClick={handleClose}><LocalizedLink to="/careers" className="subMenuItems" ><FormattedMessage id="nav.careers" /> </LocalizedLink></MenuItem> */}
                            {/* <MenuItem onClick={handleClose}><LocalizedLink to="/financing" className="subMenuItems" ><FormattedMessage id="nav.financing" /> </LocalizedLink></MenuItem> */}
                        {/* </Menu> */}
                    {/* </li>


                    <li className="menuItem" >
                        <LocalizedLink to="/contact-us"  > <span className="contactUs"  > <FormattedMessage id="nav.contact-us" /> </span> </LocalizedLink>
                    </li>
                </ul>
               
                <CtaButton windowWidth={windowWidth} />
            </nav> */}

            < div className="bottomHeader" >
                <div className="selectors" >
                    <CitySwitcher />
                    <LanguageSwitcher />
                </div>
            </div>
        </Box>
        </>
    )
};